<section class="allocation-screen">
    <main class="page">
        <header class="topbar">
            <div class="crumb-group">
                <button class="crumb">Default</button>
                <span class="chevron">›</span>
                <button class="crumb strong">Brian Hodgson | Total</button>
                <span class="currency">in EUR</span>
            </div>

            <button class="more-button">⋮</button>
        </header>

        <section class="control-bar">
            <label class="tag-search">
                <span>⌕</span>
                <input placeholder="Search tag" />
                <button>⌄</button>
            </label>

            <button class="square-button">▣</button>
            <button class="square-button">⌄</button>

            <button class="date-range">01/01/2026&nbsp;&nbsp;-&nbsp;&nbsp;12/31/2026</button>
            <button class="report-button">▣&nbsp;&nbsp;REPORTING&nbsp;&nbsp;⌄</button>
            <button class="square-button">⚙</button>

            <div class="control-spacer"></div>

            <label class="investment-filter">
                <span>⌕</span>
                <input placeholder="Investment Filter" />
            </label>
            <button class="filter-alert">▽<span>2</span></button>
        </section>

        <nav class="tabs">
            <button *ngFor="let tab of tabs" [class.active]="tab === 'Allocation'">
                {{ tab }}
            </button>
        </nav>

        <section class="chart-grid">
            <article class="chart-card">
                <h2>Sector exposure</h2>

                <div class="chart-content">
                    <div class="donut" [style.background]="doughnutBackground(sectorSegments)">
                        <div class="donut-hole"></div>
                    </div>

                    <ul class="legend">
                        <li *ngFor="let item of sectorSegments">
                            <span class="swatch" [style.background]="item.color"></span>
                            <span>{{ item.label }}:</span>
                            <strong>{{ item.value.toFixed(2) }}%</strong>
                        </li>
                    </ul>
                </div>
            </article>

            <article class="chart-card">
                <h2>Currency exposure</h2>

                <div class="chart-content compact-chart">
                    <div class="donut" [style.background]="doughnutBackground(currencySegments)">
                        <div class="donut-hole"></div>
                    </div>

                    <ul class="legend">
                        <li *ngFor="let item of currencySegments">
                            <span class="swatch" [style.background]="item.color"></span>
                            <span>{{ item.label }}:</span>
                            <strong>{{ item.value.toFixed(2) }}%</strong>
                        </li>
                    </ul>
                </div>
            </article>
        </section>

        <section class="table-tools">
            <div class="tool-icons">
                <button>↕</button>
                <button>⤢</button>
                <button>⌕</button>
                <button>⟳</button>
                <button>⌁</button>
                <button>▣</button>
                <button>⇩</button>
                <button>♢</button>
                <span>Last calculated: 4/7/2025 17:05:24</span>
            </div>

            <div class="chip-tools">
                <button>Grouping/Linking</button>
                <button>Column sets</button>
                <button>Benchmarks</button>
                <button>Threshold</button>
                <button class="wide">
                    Security (System)<span>×</span><span>⌄</span>
                </button>
            </div>
        </section>

        <section class="allocation-table-card">
            <table>
                <thead>
                <tr>
                    <th class="check-cell">
                        <input type="checkbox" aria-label="Select all" />
                    </th>
                    <th class="name-col">Name <span>↕</span></th>
                    <th>NAV 1/1/2026 <span>↕</span><small>1/1/2026</small></th>
                    <th>Asset quota 1/1/2026 <span>↕</span><small>1/1/2026</small></th>
                    <th>External cashflow <span>↕</span></th>
                    <th>Total performance YTD <span>↕</span><small>YTD</small></th>
                    <th>NAV 12/31/2026 <span>↕</span><small>12/31/2026</small></th>
                    <th class="highlight-col">
                        Asset quot... <span>↕</span><small>12/31/2026</small>
                    </th>
                    <th>Return YTD <span>↕</span><small>YTD</small></th>
                </tr>
                </thead>

                <tbody>
                <tr
                        *ngFor="let row of rows; trackBy: trackByName"
                        [class.total-row]="!row.level"
                >
                    <td class="check-cell">
                        <input type="checkbox" [attr.aria-label]="'Select ' + row.name" />
                    </td>

                    <td class="name-col" [class.indented]="row.level">
                        <span class="expander">{{ row.expanded ? '⌄' : '›' }}</span>
                        <span>{{ row.name }}</span>
                    </td>

                    <td>{{ row.navStart }}</td>
                    <td>{{ row.assetStart }}</td>
                    <td>{{ row.externalCashflow }}</td>
                    <td>{{ row.performanceYtd }}</td>
                    <td>{{ row.navEnd }}</td>

                    <td
                            class="highlight-col"
                            [class.positive]="row.positive"
                            [class.negative]="row.positive === false"
                    >
                        {{ row.assetEnd }}
                    </td>

                    <td>{{ row.returnYtd }}</td>
                </tr>
                </tbody>
            </table>
        </section>
    </main>
</section>
